import { render, staticRenderFns } from "./RewardsView.vue?vue&type=template&id=a3ea8628&scoped=true&"
import script from "./RewardsView.vue?vue&type=script&lang=js&"
export * from "./RewardsView.vue?vue&type=script&lang=js&"
import style0 from "./RewardsView.vue?vue&type=style&index=0&id=a3ea8628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ea8628",
  null
  
)

export default component.exports